import React, { useEffect, useRef, useState } from 'react';
import {
	ChartWrapper,
	TitleSection,
	Wrapper,
} from '../shared.styles';
import Input from '@/common/components/Input';
import CustomSkeleton from '@/common/components/CustomSkeleton';
import { getCPLStats } from '@/API/repositories/reports';
import { useRequestsContext } from '@/common/hooks/requestHook';
import CustomLine from '@/common/charts/Line';
import { SubTitle } from './CPLStats.styled';
import Icon from '@/common/components/Icon';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { PRODUCT_CHART_WRAPPER_HEIGHT } from '../../constants/productStatusOptions';
import { applyChartDatasetsFilter } from '../../helpers/applyChartDatasetsFilter';
import { useProductChartFilters } from '../../hooks/useProductChartFilters';
import ProductChartFilters from '../productChartFilters/ProductChartFilters';
import ProductChartActions from '../productChartFilters/ProductChartActions';

const CPLStats = () => {
	const [chartData, setChartData] = useState();
	const [rawData, setRawData] = useState();
	const timeRangeRef = useRef();

	const {
		commonData: { products },
	} = useCommonDataContext();
	const { makeRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();
	const {
		productStatus,
		setProductStatus,
		selectedProducts,
		setSelectedProducts,
		productOptions,
		handleSelectAll,
		handleUnselectAll,
	} = useProductChartFilters(products);

	const handleLoadData = async () => {
		setChartData(() => null);
		setRawData(() => null);

		if (!parseInt(timeRangeRef.current?.value)) {
			return;
		}

		const payload = {};
		payload.days = timeRangeRef.current.value;

		const response = await makeRequest(getCPLStats.bind(null, payload));

		if (!response?.data) {
			addMessage('Something went wrong', 'error');
			return;
		}

		setRawData(() => response.data);
	};

	useEffect(() => {
		applyChartDatasetsFilter({
			rawData,
			selectedProducts,
			setChartData,
		});
	}, [rawData, selectedProducts]);

	return (
		<Wrapper width={800} height={PRODUCT_CHART_WRAPPER_HEIGHT}>
			<TitleSection>
				<SubTitle>
					<Icon name='money' />
					<div>Cost per lead (Netto)</div>
				</SubTitle>
				<SubTitle>
					<Input
						inputRef={timeRangeRef}
						inputWidth={50}
						showLabel={false}
						value={0}
					/>
					<Icon name='arrows-rotate' onClick={() => handleLoadData()} />
				</SubTitle>
			</TitleSection>
			<ProductChartFilters
				productStatus={productStatus}
				setProductStatus={setProductStatus}
				productOptions={productOptions}
				selectedProducts={selectedProducts}
				setSelectedProducts={setSelectedProducts}
			/>
			<ChartWrapper>
				{chartData ? (
					<CustomLine data={chartData} />
				) : (
					<CustomSkeleton width={750} count={16} height={5} />
				)}
			</ChartWrapper>
			<ProductChartActions
				handleSelectAll={handleSelectAll}
				handleUnselectAll={handleUnselectAll}
			/>
		</Wrapper>
	);
};

export default CPLStats;
